import { useDarkMode } from "@/hooks/useDarkMode";
import { ThreeDots } from "react-loader-spinner";

const Loader = () => {
  const isDark = useDarkMode();
  return (
    <div className="fixed left-0 right-0 bottom-0 top-0 flex items-center justify-center bg-black bg-opacity-30 z-[1002] w-full h-full">
      <div className="w-[80px] h-[50px] bg-white flex justify-center items-center rounded-full">
        <ThreeDots
          visible={true}
          height="35"
          width="35"
          color={isDark ? "#D3D3D9" : "#151A36"}
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
      </div>
    </div>
  );
};

export default Loader;
